module.exports = __webpack_public_path__ + "img/myfitlogo.0cdf8594.png";